function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Outlet, useSearchParams } from 'react-router-dom';
import 'researcher/digital-orders/styles/digital-orders.scss';
import '../styles/rubriq-old.scss';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { clearTransitionModal, linkPreprintsAccount } from '../actions';
import ModalError from '../components/ModalError';
import RubriqNotificationBox from '../components/RubriqNotificationBox';
import RubriqPreprintsModal from './RubriqPreprintsModal';
import RubriqTransitionModal from './RubriqTransitionModal';
import RubriqHeader from './RubriqHeader';
var RubriqWorkspaceOld = function RubriqWorkspaceOld() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    preprintsModalOpen = _useState2[0],
    setPreprintsModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    transitionModalOpen = _useState4[0],
    setTransitionModalOpen = _useState4[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    transitionModalCleared = _useSelector.curie.acknowledgedNotifications.curieLaunchNotified;
  var dispatch = useDispatch();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var rsuid = searchParams.get('rsuid');
  var handleTransitionModalClose = function handleTransitionModalClose() {
    setTransitionModalOpen(false);

    // user has cleared the modal so let's update the associated flag in state
    dispatch(clearTransitionModal());
  };

  // check if we have a Pre-prints account to connect to Rubriq
  useEffect(function () {
    if (!rsuid) {
      return;
    }
    dispatch(linkPreprintsAccount(rsuid)).then(function (result) {
      if (result) {
        setPreprintsModalOpen(true);
      }
    });
  }, [rsuid]);

  // check if we need to show the transition modal
  useEffect(function () {
    var willShowPreprintsModal = !!rsuid;

    // don't show the transition modal if the user already saw it or if we're showing a Pre-prints modal (success or error)
    if (transitionModalCleared || willShowPreprintsModal) {
      return;
    }
    setTransitionModalOpen(true);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "curie",
    title: "Rubriq"
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-bottom"
  }, /*#__PURE__*/React.createElement(RubriqHeader, null), /*#__PURE__*/React.createElement("div", {
    className: "bg-white min-vh-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-3 pb-5"
  }, /*#__PURE__*/React.createElement(RubriqNotificationBox, null), /*#__PURE__*/React.createElement(Outlet, null))))))), /*#__PURE__*/React.createElement(ModalError, null), /*#__PURE__*/React.createElement(RubriqPreprintsModal, {
    open: preprintsModalOpen,
    onClose: function onClose() {
      return setPreprintsModalOpen(false);
    }
  }), /*#__PURE__*/React.createElement(RubriqTransitionModal, {
    open: transitionModalOpen,
    onClose: handleTransitionModalClose
  }));
};
export default RubriqWorkspaceOld;